import { render, staticRenderFns } from "./YouTubeComponent.vue?vue&type=template&id=39b35338"
import script from "./YouTubeComponent.vue?vue&type=script&lang=ts"
export * from "./YouTubeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports